import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Customer } from '../../models/customer';
import { PageBase } from '../page-base';
import { LoginProvider } from '../../providers/login/login';
import { MenuPage } from '../menu/menu';
import { NavigationListProvider } from '../../providers/navigation-list/navigation-list';
import { AlertProvider } from '../../providers/alert/alert';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-forgotpswd',
  templateUrl: 'forgotpswd.html',
})
export class ForgotpswdPage extends PageBase {
  customer: any = {email: ""};
  submitAttempt: boolean;
  forgotpswdForm: FormGroup

  constructor(private loginProvider: LoginProvider,
    private navCtrl: NavController,
    private navigationList: NavigationListProvider, 
    private formBuilder: FormBuilder) {
    super();

    this.forgotpswdForm = formBuilder.group({
      mail: ['', Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/), Validators.required])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotpswdPage');
  }

  keyPressHandler(keyCode) 
  {
    if(keyCode == 13) {
      this.Forgotpswd();
    }
  }

  async Forgotpswd() {
    if(!this.forgotpswdForm.valid) {
      this.submitAttempt = true;
      return;
    }
    this.loginProvider.sendForgotPSWDMail(this.customer).then(x => {
      if(!x){
        this.submitAttempt = true;
      } else {
	    this.submitAttempt = false;
        this.alertProvider.simple('FORGOTPSWD.TITLE', 'FORGOTPSWD.SUCCESS');
      }
    }).catch(error => {
      this.submitAttempt = true;
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/forgotpswd/forgotpswd.ts